import { render, staticRenderFns } from "./editReward.vue?vue&type=template&id=2c737906&scoped=true&"
import script from "./editReward.vue?vue&type=script&lang=js&"
export * from "./editReward.vue?vue&type=script&lang=js&"
import style0 from "./editReward.vue?vue&type=style&index=0&id=2c737906&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c737906",
  null
  
)

export default component.exports